import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ConnectorsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  marginBottom: '40px',
  paddingRight: '5px',
  overflow: 'auto',

  [theme.breakpoints.down('sm')]: {
    marginBottom: '32px',
    paddingRight: '0',
    maxWidth: '100%',
  },
}));

export const SubTitle = styled(Typography)(() => ({
  fontSize: '16px',
  lineHeight: '20.8px',
  fontWeight: '500',
  marginBottom: '10px',
}));

export const Title = styled(Typography)(({ theme }: any) => ({
  color: theme.palette.primary.main,
  marginBottom: '20px',
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '415px',
  overflow: 'hidden',
  minHeight: '100vh', // Altezza fissa come le altre pagine
  backgroundColor: theme.palette.background.default,
  padding: '24px',
  marginLeft: '240px',
  width: 'calc(100% - 240px)',
  boxSizing: 'border-box',

  [theme.breakpoints.down('lg')]: {
    marginLeft: '220px',
    width: 'calc(100% - 220px)',
    padding: '20px',
  },

  [theme.breakpoints.down('md')]: {
    marginLeft: '200px',
    width: 'calc(100% - 200px)',
    padding: '16px',
  },

  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    width: '100%',
    padding: '16px',
    marginTop: '60px', // Spazio per header mobile
    maxWidth: '100%',
    overflow: 'visible',

    '.MuiTypography-h3': {
      marginBottom: '15px',
      textAlign: 'center',
    },
  },

  [theme.breakpoints.down('xs')]: {
    padding: '12px',
  },
}));
